import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-newdashboard',
  templateUrl: './newdashboard.component.html',
  styleUrls: ['./newdashboard.component.scss']
})
export class NewdashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
